import { useEffect, useRef, useState } from "react";
import { Button } from "../ui/button";
import { toast } from "sonner";
import { Loader2, Trash2, Upload } from "lucide-react";
import { addMailLibrary, deleteMailLibrary, listMailLibrary } from "../../services/crmServices/mailService";

export function MailLibraryPanel() {
    const [rows, setRows] = useState([]);
    const [busy, setBusy] = useState(false);
    const fileRef = useRef(null);

    const load = async () => {
        const res = await listMailLibrary();
        setRows(res.data || []);
    };

    useEffect(() => {
        load().catch((err) => toast.error(err.response?.data?.message || "Failed to load library"));
    }, []);

    const onFile = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) return;
        setBusy(true);
        try {
            const fd = new FormData();
            fd.append("file", file);
            const res = await addMailLibrary(fd);
            if (res.status !== 200) throw new Error(res.message);
            toast.success("Added to library");
            await load();
        } catch (err) {
            toast.error(err.response?.data?.message || err.message || "Upload failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="bg-white border border-gray-200 rounded-lg p-4 space-y-3">
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="text-sm font-semibold">Attachment library</h3>
                    <p className="text-xs text-gray-500">Brochures and forms you attach often.</p>
                </div>
                <input ref={fileRef} type="file" className="hidden" onChange={onFile} />
                <Button size="sm" onClick={() => fileRef.current?.click()} disabled={busy} className="bg-red-600 hover:bg-red-700">
                    {busy ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Upload className="h-4 w-4 mr-1" />}
                    Upload
                </Button>
            </div>
            <div className="divide-y">
                {rows.map((r) => (
                    <div key={r._id} className="flex items-center justify-between py-2">
                        <div>
                            <p className="text-sm font-medium">{r.originalName}</p>
                            <p className="text-xs text-gray-400">{Math.round((r.size || 0) / 1024)} KB</p>
                        </div>
                        <Button
                            size="sm"
                            variant="outline"
                            className="text-red-600"
                            onClick={async () => {
                                await deleteMailLibrary(r._id);
                                load();
                            }}
                        >
                            <Trash2 className="h-4 w-4" />
                        </Button>
                    </div>
                ))}
                {rows.length === 0 && <p className="text-sm text-gray-400 py-6 text-center">No files yet</p>}
            </div>
        </div>
    );
}
